export const ukUniversities = {
  "university-of-edinburgh": {
    slug: "university-of-edinburgh", country: "uk",
    name: "University of Edinburgh", shortName: "Edinburgh", flag: "🇬🇧",
    city: "Edinburgh, Scotland", founded: 1583, qsRank: "#22 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of the UK's ancient universities (est. 1583) and consistently ranked in the global top 25. Edinburgh is the world's #1 for Informatics and a top choice for medicine, law, and business. Alumni include Charles Darwin, Sir Arthur Conan Doyle, and Tony Blair.",
    tuition: { domestic: "£9,250/yr", international: "£23,000–£33,000/yr" },
    living: "£900–£1,300/mo", ielts: "6.5+", gre: "Program-dependent",
    topCourses: [
      { name: "MSc Artificial Intelligence", duration: "1 year", language: "English" },
      { name: "MSc Data Science", duration: "1 year", language: "English" },
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Finance", duration: "1 year", language: "English" },
      { name: "MBA — Edinburgh Business School", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "£32,000–£52,000", topEmployers: ["Amazon", "Skyscanner", "Deloitte", "Morgan Stanley", "NHS"] },
    intakes: ["September"], istpStudents: 42,
  },

  "university-of-manchester": {
    slug: "university-of-manchester", country: "uk",
    name: "University of Manchester", shortName: "Manchester", flag: "🇬🇧",
    city: "Manchester, England", founded: 1824, qsRank: "#34 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A Russell Group university with 25 Nobel laureates and a global reputation for science, engineering, and management. Manchester's strong industry links with the Northern Powerhouse make it a top choice for career-focused students.",
    tuition: { domestic: "£9,250/yr", international: "£20,000–£29,000/yr" },
    living: "£800–£1,200/mo", ielts: "6.5+", gre: "Not required",
    topCourses: [
      { name: "MSc Advanced Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Business Analytics", duration: "1 year", language: "English" },
      { name: "MSc Biotechnology", duration: "1 year", language: "English" },
      { name: "MBA — Manchester Business School", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "£30,000–£48,000", topEmployers: ["AstraZeneca", "Barclays", "Kellogg's", "PwC", "BT Group"] },
    intakes: ["September"], istpStudents: 38,
  },

  "queen-mary-london": {
    slug: "queen-mary-london", country: "uk",
    name: "Queen Mary University of London", shortName: "QMUL", flag: "🇬🇧",
    city: "London, England", founded: 1785, qsRank: "#148 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1486325212027-8081e485255e?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Part of the Russell Group and located in London's vibrant East End. QMUL is a top-10 UK university for research impact and offers unrivalled access to London's finance, tech, and legal sectors. Popular with Indian students for its accessibility and strong placement record.",
    tuition: { domestic: "£9,250/yr", international: "£18,000–£26,000/yr" },
    living: "£1,100–£1,600/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Investment & Finance", duration: "1 year", language: "English" },
      { name: "MSc Digital Media & Communications", duration: "1 year", language: "English" },
      { name: "MSc Law", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "£28,000–£44,000", topEmployers: ["Goldman Sachs", "BBC", "Allen & Overy", "Accenture", "TfL"] },
    intakes: ["September", "January"], istpStudents: 28,
  },

  "university-of-glasgow": {
    slug: "university-of-glasgow", country: "uk",
    name: "University of Glasgow", shortName: "Glasgow", flag: "🇬🇧",
    city: "Glasgow, Scotland", founded: 1451, qsRank: "#78 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of the UK's ancient universities (est. 1451) and a Russell Group member. Glasgow excels in engineering, medicine, and computing. Lower cost of living than London with excellent career opportunities.",
    tuition: { domestic: "£9,250/yr", international: "£18,000–£28,000/yr" },
    living: "£800–£1,100/mo", ielts: "6.5+", gre: "Not required",
    topCourses: [
      { name: "MSc Computing Science", duration: "1 year", language: "English" },
      { name: "MSc Financial Technology", duration: "1 year", language: "English" },
      { name: "MSc Aerospace Engineering", duration: "1 year", language: "English" },
      { name: "MSc International Business & Entrepreneurship", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "£28,000–£45,000", topEmployers: ["Rolls-Royce", "KPMG", "NHS", "Barclays", "Diageo"] },
    intakes: ["September"], istpStudents: 31,
  },

  "imperial-college-london": {
    slug: "imperial-college-london", country: "uk",
    name: "Imperial College London", shortName: "Imperial", flag: "🇬🇧",
    city: "London, England", founded: 1907, qsRank: "#2 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1486325212027-8081e485255e?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The world's #2 university and the UK's top STEM institution. Imperial is where future engineers, scientists, doctors, and entrepreneurs are forged. Located in South Kensington — the heart of London's knowledge economy.",
    tuition: { domestic: "£9,250/yr", international: "£29,000–£40,000/yr" },
    living: "£1,200–£1,800/mo", ielts: "6.5+", gre: "Required for most programs",
    topCourses: [
      { name: "MSc Computing (Artificial Intelligence)", duration: "1 year", language: "English" },
      { name: "MSc Electrical & Electronic Engineering", duration: "1 year", language: "English" },
      { name: "MBA — Imperial Business School", duration: "1 year", language: "English" },
      { name: "MSc Environmental Engineering", duration: "1 year", language: "English" },
      { name: "MSc Biomedical Engineering", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "96%", avgSalary: "£42,000–£72,000", topEmployers: ["Google", "Goldman Sachs", "McKinsey", "BP", "Rolls-Royce"] },
    intakes: ["September", "January (limited)"], istpStudents: 22,
  },

  "ucl": {
    slug: "ucl", country: "uk",
    name: "University College London", shortName: "UCL", flag: "🇬🇧",
    city: "London, England", founded: 1826, qsRank: "#9 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1486325212027-8081e485255e?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "London's global university and consistently in the world top 10. UCL is renowned for its multidisciplinary approach across 11 faculties. Located in Bloomsbury — London's academic and cultural heartland.",
    tuition: { domestic: "£9,250/yr", international: "£24,000–£36,000/yr" },
    living: "£1,200–£1,800/mo", ielts: "6.5+", gre: "Program-dependent",
    topCourses: [
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Data Science & Machine Learning", duration: "1 year", language: "English" },
      { name: "MSc Financial Risk Management", duration: "1 year", language: "English" },
      { name: "MSc Architecture", duration: "1 year", language: "English" },
      { name: "MBA — UCL School of Management", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "£38,000–£65,000", topEmployers: ["Amazon", "HSBC", "Deloitte", "NHS", "Google"] },
    intakes: ["September"], istpStudents: 35,
  },

  "kings-college-london": {
    slug: "kings-college-london", country: "uk",
    name: "King's College London", shortName: "KCL", flag: "🇬🇧",
    city: "London, England", founded: 1829, qsRank: "#40 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1486325212027-8081e485255e?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A Russell Group university on the Thames with world-leading medicine, law, and humanities. KCL has shaped some of history's greatest minds — from Florence Nightingale to Desmond Tutu. Prime London location across five campuses.",
    tuition: { domestic: "£9,250/yr", international: "£22,000–£32,000/yr" },
    living: "£1,200–£1,800/mo", ielts: "6.5+", gre: "Not required",
    topCourses: [
      { name: "MSc Advanced Software Engineering", duration: "1 year", language: "English" },
      { name: "MSc International Political Economy", duration: "1 year", language: "English" },
      { name: "MSc Medical Imaging", duration: "1 year", language: "English" },
      { name: "LLM International Business Law", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "£34,000–£55,000", topEmployers: ["NHS", "Clifford Chance", "PwC", "Goldman Sachs", "Pfizer"] },
    intakes: ["September"], istpStudents: 29,
  },

  "lse": {
    slug: "lse", country: "uk",
    name: "London School of Economics & Political Science", shortName: "LSE", flag: "🇬🇧",
    city: "London, England", founded: 1895, qsRank: "#50 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1486325212027-8081e485255e?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The world's leading social science university. 18 Nobel Prize winners. LSE alumni run central banks, lead global companies, and shape international policy. An unmatched launchpad for finance, economics, and public policy careers.",
    tuition: { domestic: "£9,250/yr", international: "£22,000–£34,000/yr" },
    living: "£1,300–£1,900/mo", ielts: "7.0+", gre: "Required for some programs",
    topCourses: [
      { name: "MSc Finance", duration: "1 year", language: "English" },
      { name: "MSc Financial Mathematics", duration: "1 year", language: "English" },
      { name: "MSc Data Science", duration: "1 year", language: "English" },
      { name: "MSc Management", duration: "1 year", language: "English" },
      { name: "MSc International Relations", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "£42,000–£78,000", topEmployers: ["Goldman Sachs", "IMF", "World Bank", "McKinsey", "BlackRock"] },
    intakes: ["September"], istpStudents: 18,
  },

  "university-of-warwick": {
    slug: "university-of-warwick", country: "uk",
    name: "University of Warwick", shortName: "Warwick", flag: "🇬🇧",
    city: "Coventry, England", founded: 1965, qsRank: "#69 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A Russell Group university consistently ranked among the UK's top 10. Warwick Business School is one of the world's elite — ranked #1 in the UK for MBA. Strong in mathematics, engineering, and economics.",
    tuition: { domestic: "£9,250/yr", international: "£22,000–£30,000/yr" },
    living: "£850–£1,200/mo", ielts: "6.5+", gre: "Required for some programs",
    topCourses: [
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Business Analytics", duration: "1 year", language: "English" },
      { name: "MBA — Warwick Business School", duration: "1 year", language: "English" },
      { name: "MSc Mathematics", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "£35,000–£58,000", topEmployers: ["Jaguar Land Rover", "Deloitte", "PwC", "HSBC", "Amazon"] },
    intakes: ["September"], istpStudents: 26,
  },

  "university-of-bristol": {
    slug: "university-of-bristol", country: "uk",
    name: "University of Bristol", shortName: "Bristol", flag: "🇬🇧",
    city: "Bristol, England", founded: 1909, qsRank: "#55 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A prestigious Russell Group university in the UK's most vibrant city. Strong in aerospace, computer science, law, and economics. Bristol is the UK's top startup city outside London.",
    tuition: { domestic: "£9,250/yr", international: "£22,000–£30,000/yr" },
    living: "£900–£1,300/mo", ielts: "6.5+", gre: "Not required",
    topCourses: [
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Aerospace Engineering", duration: "1 year", language: "English" },
      { name: "MSc Economics", duration: "1 year", language: "English" },
      { name: "MSc Robotics", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "£32,000–£52,000", topEmployers: ["Airbus", "Rolls-Royce", "Aardman", "PwC", "BAE Systems"] },
    intakes: ["September"], istpStudents: 24,
  },

  "university-of-leeds": {
    slug: "university-of-leeds", country: "uk",
    name: "University of Leeds", shortName: "Leeds", flag: "🇬🇧",
    city: "Leeds, England", founded: 1904, qsRank: "#82 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A Russell Group university with one of the UK's largest student communities. Particularly strong in fashion, food science, civil engineering, and business. Leeds is the UK's fastest-growing digital city.",
    tuition: { domestic: "£9,250/yr", international: "£19,000–£26,000/yr" },
    living: "£800–£1,100/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Data Science & Analytics", duration: "1 year", language: "English" },
      { name: "MSc International Business", duration: "1 year", language: "English" },
      { name: "MSc Civil Engineering", duration: "1 year", language: "English" },
      { name: "MSc Food Science", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "89%", avgSalary: "£28,000–£44,000", topEmployers: ["ASDA", "Channel 4", "Sky", "PwC", "NHS"] },
    intakes: ["September"], istpStudents: 33,
  },

  "university-of-sheffield": {
    slug: "university-of-sheffield", country: "uk",
    name: "University of Sheffield", shortName: "Sheffield", flag: "🇬🇧",
    city: "Sheffield, England", founded: 1905, qsRank: "#101 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A Russell Group university world-renowned for engineering. Home to the AMRC (Advanced Manufacturing Research Centre) — a global hub for aerospace and advanced manufacturing in partnership with Boeing and Rolls-Royce.",
    tuition: { domestic: "£9,250/yr", international: "£18,000–£26,000/yr" },
    living: "£750–£1,050/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Advanced Manufacturing Engineering", duration: "1 year", language: "English" },
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Structural Engineering", duration: "1 year", language: "English" },
      { name: "MBA — Sheffield Business School", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "£29,000–£46,000", topEmployers: ["Boeing", "Rolls-Royce", "KPMG", "NHS", "Airbus"] },
    intakes: ["September"], istpStudents: 27,
  },

  "university-of-nottingham": {
    slug: "university-of-nottingham", country: "uk",
    name: "University of Nottingham", shortName: "Nottingham", flag: "🇬🇧",
    city: "Nottingham, England", founded: 1881, qsRank: "#103 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A Russell Group university with stunning campus and global reach — campuses in UK, China, and Malaysia. Ranked #1 UK university for graduate employer perception. Strong in pharmacy, engineering, and business.",
    tuition: { domestic: "£9,250/yr", international: "£19,000–£27,000/yr" },
    living: "£750–£1,050/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Computer Science with Artificial Intelligence", duration: "1 year", language: "English" },
      { name: "MSc International Business", duration: "1 year", language: "English" },
      { name: "MSc Drug Discovery", duration: "1 year", language: "English" },
      { name: "MBA — Nottingham University Business School", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "£29,000–£47,000", topEmployers: ["Boots", "Experian", "Capital One", "PwC", "NHS"] },
    intakes: ["September"], istpStudents: 30,
  },

  "university-of-birmingham": {
    slug: "university-of-birmingham", country: "uk",
    name: "University of Birmingham", shortName: "Birmingham", flag: "🇬🇧",
    city: "Birmingham, England", founded: 1900, qsRank: "#84 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The original redbrick university and a founding Russell Group member. Birmingham excels in law, medicine, engineering, and finance. The city recently hosted the 2022 Commonwealth Games — a symbol of its global rise.",
    tuition: { domestic: "£9,250/yr", international: "£19,000–£27,000/yr" },
    living: "£800–£1,100/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Finance", duration: "1 year", language: "English" },
      { name: "MSc Mechanical Engineering", duration: "1 year", language: "English" },
      { name: "LLM Commercial Law", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "£29,000–£46,000", topEmployers: ["HSBC", "Jaguar Land Rover", "Deloitte", "PwC", "NHS"] },
    intakes: ["September"], istpStudents: 25,
  },

  "university-of-southampton": {
    slug: "university-of-southampton", country: "uk",
    name: "University of Southampton", shortName: "Southampton", flag: "🇬🇧",
    city: "Southampton, England", founded: 1952, qsRank: "#81 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A Russell Group research powerhouse — inventor of fibre optic broadband. World-class in electronics, acoustic engineering, and oceanography. Home to the National Oceanography Centre.",
    tuition: { domestic: "£9,250/yr", international: "£19,000–£27,000/yr" },
    living: "£800–£1,100/mo", ielts: "6.5+", gre: "Not required",
    topCourses: [
      { name: "MSc Data Science", duration: "1 year", language: "English" },
      { name: "MSc Electronic Engineering", duration: "1 year", language: "English" },
      { name: "MSc Maritime Engineering Science", duration: "1 year", language: "English" },
      { name: "MSc Wealth Management", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "£30,000–£48,000", topEmployers: ["BAE Systems", "Rolls-Royce", "IBM", "Barclays", "P&O Cruises"] },
    intakes: ["September"], istpStudents: 22,
  },

  "university-of-exeter": {
    slug: "university-of-exeter", country: "uk",
    name: "University of Exeter", shortName: "Exeter", flag: "🇬🇧",
    city: "Exeter, England", founded: 1955, qsRank: "#167 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A Russell Group university set in stunning Devon countryside. Particularly strong in business, law, and environmental science. Exeter Business School is ranked in the global top 100 by the FT.",
    tuition: { domestic: "£9,250/yr", international: "£19,000–£27,000/yr" },
    living: "£800–£1,100/mo", ielts: "6.5+", gre: "Not required",
    topCourses: [
      { name: "MSc Business Analytics", duration: "1 year", language: "English" },
      { name: "MBA — Exeter Business School", duration: "1 year", language: "English" },
      { name: "MSc Climate Change", duration: "1 year", language: "English" },
      { name: "MSc Financial Data Science", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "£29,000–£46,000", topEmployers: ["KPMG", "EY", "NHS", "PwC", "Met Office"] },
    intakes: ["September"], istpStudents: 20,
  },

  "university-of-bath": {
    slug: "university-of-bath", country: "uk",
    name: "University of Bath", shortName: "Bath", flag: "🇬🇧",
    city: "Bath, England", founded: 1966, qsRank: "#177 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The UK's #1 university for graduate employment rate. Bath is consistently top 10 in every major UK ranking. Famous for its placement year programme — students work at global companies before finishing their degree.",
    tuition: { domestic: "£9,250/yr", international: "£19,500–£26,500/yr" },
    living: "£850–£1,200/mo", ielts: "6.5+", gre: "Not required",
    topCourses: [
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Mechanical Engineering", duration: "1 year", language: "English" },
      { name: "MBA — School of Management", duration: "1 year", language: "English" },
      { name: "MSc Finance", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "96%", avgSalary: "£33,000–£54,000", topEmployers: ["Dyson", "Rolls-Royce", "PwC", "Goldman Sachs", "NHS"] },
    intakes: ["September"], istpStudents: 19,
  },

  "university-of-durham": {
    slug: "university-of-durham", country: "uk",
    name: "Durham University", shortName: "Durham", flag: "🇬🇧",
    city: "Durham, England", founded: 1832, qsRank: "#78 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "England's third-oldest university with a collegiate system inspired by Oxford and Cambridge. Spectacular cathedral city campus. Ranked #1 in the UK for student satisfaction. Strong in law, physics, and business.",
    tuition: { domestic: "£9,250/yr", international: "£19,000–£26,000/yr" },
    living: "£800–£1,100/mo", ielts: "6.5+", gre: "Not required",
    topCourses: [
      { name: "MSc Finance", duration: "1 year", language: "English" },
      { name: "MSc Engineering", duration: "1 year", language: "English" },
      { name: "MBA — Durham University Business School", duration: "1 year", language: "English" },
      { name: "MSc Data Science", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "£31,000–£50,000", topEmployers: ["Barclays", "KPMG", "Deloitte", "PwC", "EY"] },
    intakes: ["September"], istpStudents: 21,
  },

  "university-of-york": {
    slug: "university-of-york", country: "uk",
    name: "University of York", shortName: "York", flag: "🇬🇧",
    city: "York, England", founded: 1963, qsRank: "#187 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A Russell Group university set in a beautiful lake campus in historic York. World-renowned for cognitive science, computer science, and environmental science. Very high student satisfaction ratings.",
    tuition: { domestic: "£9,250/yr", international: "£18,500–£25,500/yr" },
    living: "£800–£1,100/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Artificial Intelligence", duration: "1 year", language: "English" },
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Environmental Management", duration: "1 year", language: "English" },
      { name: "MSc Health Sciences", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "89%", avgSalary: "£28,000–£44,000", topEmployers: ["Google", "BBC", "NHS", "Barclays", "Dyson"] },
    intakes: ["September"], istpStudents: 18,
  },

  "lancaster-university": {
    slug: "lancaster-university", country: "uk",
    name: "Lancaster University", shortName: "Lancaster", flag: "🇬🇧",
    city: "Lancaster, England", founded: 1964, qsRank: "#140 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Consistently in the UK top 10. Lancaster University Management School is triple-accredited and ranked among Europe's best. Beautiful self-contained campus in the English countryside.",
    tuition: { domestic: "£9,250/yr", international: "£18,000–£24,000/yr" },
    living: "£750–£1,050/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Data Science", duration: "1 year", language: "English" },
      { name: "MBA — Lancaster University Management School", duration: "1 year", language: "English" },
      { name: "MSc Finance", duration: "1 year", language: "English" },
      { name: "MSc Cyber Security", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "£30,000–£48,000", topEmployers: ["BAE Systems", "PwC", "NHS", "Deloitte", "IBM"] },
    intakes: ["September"], istpStudents: 17,
  },

  "loughborough-university": {
    slug: "loughborough-university", country: "uk",
    name: "Loughborough University", shortName: "Loughborough", flag: "🇬🇧",
    city: "Loughborough, England", founded: 1909, qsRank: "#224 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The UK's #1 university for sports science and engineering. Loughborough has won the Times Higher Education 'University of the Year' multiple times. Outstanding for aeronautical engineering and design.",
    tuition: { domestic: "£9,250/yr", international: "£18,500–£24,500/yr" },
    living: "£750–£1,050/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Aeronautical Engineering", duration: "1 year", language: "English" },
      { name: "MSc Sport & Exercise Science", duration: "1 year", language: "English" },
      { name: "MSc Design & Innovation", duration: "1 year", language: "English" },
      { name: "MSc Information Technology", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "£30,000–£48,000", topEmployers: ["Jaguar Land Rover", "Rolls-Royce", "McLaren", "PwC", "P&G"] },
    intakes: ["September"], istpStudents: 16,
  },

  "university-of-surrey": {
    slug: "university-of-surrey", country: "uk",
    name: "University of Surrey", shortName: "Surrey", flag: "🇬🇧",
    city: "Guildford, England", founded: 1966, qsRank: "#384 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The UK's #1 university for graduate employment (Prospects). Located in Guildford — 30 minutes from London. Renowned for professional training years and 5G/IoT research at the Surrey Technology Park.",
    tuition: { domestic: "£9,250/yr", international: "£18,000–£24,000/yr" },
    living: "£900–£1,300/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Artificial Intelligence", duration: "1 year", language: "English" },
      { name: "MSc 5G & Future Telecommunications", duration: "1 year", language: "English" },
      { name: "MSc International Hotel Management", duration: "1 year", language: "English" },
      { name: "MSc Business Analytics", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "£30,000–£48,000", topEmployers: ["Samsung", "Ericsson", "Microsoft", "Hilton", "NHS"] },
    intakes: ["September"], istpStudents: 15,
  },

  "aston-university": {
    slug: "aston-university", country: "uk",
    name: "Aston University", shortName: "Aston", flag: "🇬🇧",
    city: "Birmingham, England", founded: 1895, qsRank: "#451 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Ranked #1 in the UK for graduate employability by the Guardian. Aston Business School is triple-accredited. Known for pharmacy, engineering, and business with mandatory placement years.",
    tuition: { domestic: "£9,250/yr", international: "£17,500–£23,000/yr" },
    living: "£800–£1,100/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Data Science", duration: "1 year", language: "English" },
      { name: "MBA — Aston Business School", duration: "1 year", language: "English" },
      { name: "MSc Pharmacy", duration: "1 year", language: "English" },
      { name: "MSc Engineering Management", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "£29,000–£46,000", topEmployers: ["HSBC", "Jaguar Land Rover", "NHS", "PwC", "Deloitte"] },
    intakes: ["September"], istpStudents: 23,
  },

  "newcastle-university": {
    slug: "newcastle-university", country: "uk",
    name: "Newcastle University", shortName: "Newcastle", flag: "🇬🇧",
    city: "Newcastle upon Tyne, England", founded: 1834, qsRank: "#164 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A Russell Group research university in the vibrant North East. World-leading in marine science, ageing research, and digital humanities. Newcastle Business School is AACSB-accredited.",
    tuition: { domestic: "£9,250/yr", international: "£18,500–£25,500/yr" },
    living: "£750–£1,050/mo", ielts: "6.5+", gre: "Not required",
    topCourses: [
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Marine Technology", duration: "1 year", language: "English" },
      { name: "MBA — Newcastle Business School", duration: "1 year", language: "English" },
      { name: "MSc Financial Management", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "89%", avgSalary: "£28,000–£44,000", topEmployers: ["Sage", "Nissan", "PwC", "NHS", "Deloitte"] },
    intakes: ["September"], istpStudents: 20,
  },

  "university-of-leicester": {
    slug: "university-of-leicester", country: "uk",
    name: "University of Leicester", shortName: "Leicester", flag: "🇬🇧",
    city: "Leicester, England", founded: 1921, qsRank: "#375 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Where DNA fingerprinting was discovered. A research-focused Russell Group associate with outstanding space science and genetics departments. Leicester has the UK's most diverse student community.",
    tuition: { domestic: "£9,250/yr", international: "£17,500–£22,500/yr" },
    living: "£750–£1,050/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Data Science", duration: "1 year", language: "English" },
      { name: "MSc Space Science", duration: "1 year", language: "English" },
      { name: "MSc Genetics", duration: "1 year", language: "English" },
      { name: "MBA — School of Business", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "£27,000–£43,000", topEmployers: ["NHS", "KPMG", "Caterpillar", "Santander", "Rolls-Royce"] },
    intakes: ["September"], istpStudents: 16,
  },

  "university-of-reading": {
    slug: "university-of-reading", country: "uk",
    name: "University of Reading", shortName: "Reading", flag: "🇬🇧",
    city: "Reading, England", founded: 1892, qsRank: "#246 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "World #1 for meteorology and climate science. Home to the ECMWF (European Centre for Medium-Range Weather Forecasts). 30 minutes from London Paddington — ideal for Thames Valley tech jobs.",
    tuition: { domestic: "£9,250/yr", international: "£17,500–£23,000/yr" },
    living: "£900–£1,300/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Applied Meteorology", duration: "1 year", language: "English" },
      { name: "MSc International Business & Finance", duration: "1 year", language: "English" },
      { name: "MSc Food Science", duration: "1 year", language: "English" },
      { name: "MSc Data Science", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "£28,000–£44,000", topEmployers: ["Microsoft", "Oracle", "Vodafone", "ECMWF", "Met Office"] },
    intakes: ["September"], istpStudents: 14,
  },

  "city-university-london": {
    slug: "city-university-london", country: "uk",
    name: "City, University of London", shortName: "City London", flag: "🇬🇧",
    city: "London, England", founded: 1894, qsRank: "#407 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1486325212027-8081e485255e?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Located in the heart of London's financial district. Cass Business School (now Bayes) is one of Europe's top business schools. Excellent for finance, insurance, actuarial science, and journalism.",
    tuition: { domestic: "£9,250/yr", international: "£18,000–£24,000/yr" },
    living: "£1,200–£1,800/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Finance", duration: "1 year", language: "English" },
      { name: "MSc Actuarial Science", duration: "1 year", language: "English" },
      { name: "MBA — Bayes Business School", duration: "1 year", language: "English" },
      { name: "MSc Data Science", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "£33,000–£55,000", topEmployers: ["Lloyd's of London", "KPMG", "Goldman Sachs", "Barclays", "Bloomberg"] },
    intakes: ["September"], istpStudents: 22,
  },

  "brunel-university": {
    slug: "brunel-university", country: "uk",
    name: "Brunel University London", shortName: "Brunel", flag: "🇬🇧",
    city: "Uxbridge, London", founded: 1966, qsRank: "#451 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1486325212027-8081e485255e?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Named after the great Victorian engineer Isambard Kingdom Brunel. West London campus with excellent links to Heathrow, tech companies, and media. Strong in engineering, design, and business.",
    tuition: { domestic: "£9,250/yr", international: "£17,500–£23,000/yr" },
    living: "£1,000–£1,500/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Mechanical Engineering", duration: "1 year", language: "English" },
      { name: "MBA — Brunel Business School", duration: "1 year", language: "English" },
      { name: "MSc Engineering Management", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "£28,000–£44,000", topEmployers: ["Jaguar Land Rover", "BAE Systems", "Sky", "BT", "KPMG"] },
    intakes: ["September", "January"], istpStudents: 19,
  },

  "university-of-st-andrews": {
    slug: "university-of-st-andrews", country: "uk",
    name: "University of St Andrews", shortName: "St Andrews", flag: "🇬🇧",
    city: "St Andrews, Scotland", founded: 1413, qsRank: "#96 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Scotland's oldest university and consistently among the UK's top 5. The alma mater of Prince William and Kate Middleton. World-class in astrophysics, philosophy, international relations, and medicine.",
    tuition: { domestic: "£9,250/yr", international: "£20,000–£29,000/yr" },
    living: "£800–£1,100/mo", ielts: "6.5+", gre: "Program-dependent",
    topCourses: [
      { name: "MSc Astrophysics", duration: "1 year", language: "English" },
      { name: "MSc International Relations", duration: "1 year", language: "English" },
      { name: "MSc Sustainable Development", duration: "1 year", language: "English" },
      { name: "MSc Data Science", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "£30,000–£50,000", topEmployers: ["Goldman Sachs", "Deloitte", "Google", "NATO", "UN"] },
    intakes: ["September"], istpStudents: 12,
  },

  "heriot-watt-university": {
    slug: "heriot-watt-university", country: "uk",
    name: "Heriot-Watt University", shortName: "Heriot-Watt", flag: "🇬🇧",
    city: "Edinburgh, Scotland", founded: 1821, qsRank: "#351 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The world's first mechanics institute. Campuses in Edinburgh, Dubai, and Malaysia. Globally renowned for engineering, computer science, and business with a very strong international outlook.",
    tuition: { domestic: "£9,250/yr", international: "£16,500–£22,000/yr" },
    living: "£800–£1,100/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Petroleum Engineering", duration: "1 year", language: "English" },
      { name: "MBA — Edinburgh Business School", duration: "1–2 years", language: "English" },
      { name: "MSc Robotics & Autonomous Systems", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "89%", avgSalary: "£28,000–£46,000", topEmployers: ["Shell", "BP", "IBM", "Accenture", "Wood Group"] },
    intakes: ["September"], istpStudents: 17,
  },

  "university-of-strathclyde": {
    slug: "university-of-strathclyde", country: "uk",
    name: "University of Strathclyde", shortName: "Strathclyde", flag: "🇬🇧",
    city: "Glasgow, Scotland", founded: 1796, qsRank: "#298 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Three-time Times Higher Education UK University of the Year. Strathclyde Business School is the UK's only triple-accredited business school outside Russell Group. Strong in engineering and pharmacy.",
    tuition: { domestic: "£9,250/yr", international: "£16,500–£23,000/yr" },
    living: "£800–£1,100/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Computer & Information Sciences", duration: "1 year", language: "English" },
      { name: "MBA — Strathclyde Business School", duration: "1 year", language: "English" },
      { name: "MSc Advanced Chemical Engineering", duration: "1 year", language: "English" },
      { name: "MSc International Accounting & Finance", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "£29,000–£47,000", topEmployers: ["BAE Systems", "Weir Group", "KPMG", "Deloitte", "NHS"] },
    intakes: ["September"], istpStudents: 18,
  },

  "queens-belfast": {
    slug: "queens-belfast", country: "uk",
    name: "Queen's University Belfast", shortName: "Queen's Belfast", flag: "🇬🇧",
    city: "Belfast, Northern Ireland", founded: 1845, qsRank: "#235 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "A Russell Group university in Belfast — the UK's most affordable capital city for students. Strong in law, engineering, and computer science. The city's tech boom (home to Citi, Liberty Mutual, Allstate) creates excellent graduate prospects.",
    tuition: { domestic: "£9,250/yr", international: "£16,500–£22,000/yr" },
    living: "£650–£950/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Advanced Software Engineering", duration: "1 year", language: "English" },
      { name: "LLM International Business Law", duration: "1 year", language: "English" },
      { name: "MBA — Queen's Business School", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "89%", avgSalary: "£27,000–£43,000", topEmployers: ["Citi", "Allstate", "Liberty Mutual", "PwC", "Deloitte"] },
    intakes: ["September"], istpStudents: 15,
  },

  "cardiff-university": {
    slug: "cardiff-university", country: "uk",
    name: "Cardiff University", shortName: "Cardiff", flag: "🇬🇧",
    city: "Cardiff, Wales", founded: 1883, qsRank: "#191 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Wales's leading Russell Group university. Strong in journalism, engineering, and biosciences. Cardiff is the UK's youngest capital city — vibrant, affordable, and rapidly growing tech ecosystem.",
    tuition: { domestic: "£9,250/yr", international: "£18,000–£24,000/yr" },
    living: "£750–£1,050/mo", ielts: "6.5+", gre: "Not required",
    topCourses: [
      { name: "MSc Computer Science & Informatics", duration: "1 year", language: "English" },
      { name: "MSc Journalism", duration: "1 year", language: "English" },
      { name: "MSc Engineering", duration: "1 year", language: "English" },
      { name: "MBA — Cardiff Business School", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "89%", avgSalary: "£27,000–£43,000", topEmployers: ["BBC Wales", "NHS", "KPMG", "PwC", "Admiral Insurance"] },
    intakes: ["September"], istpStudents: 14,
  },

  "university-of-aberdeen": {
    slug: "university-of-aberdeen", country: "uk",
    name: "University of Aberdeen", shortName: "Aberdeen", flag: "🇬🇧",
    city: "Aberdeen, Scotland", founded: 1495, qsRank: "#238 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Scotland's third-oldest university (est. 1495) in the UK's oil and gas capital. World-class in petroleum engineering, marine biology, and law. Strong industry connections to BP, Shell, and TotalEnergies.",
    tuition: { domestic: "£9,250/yr", international: "£16,500–£22,000/yr" },
    living: "£800–£1,100/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Petroleum Engineering", duration: "1 year", language: "English" },
      { name: "MSc Computing Science", duration: "1 year", language: "English" },
      { name: "LLM Oil & Gas Law", duration: "1 year", language: "English" },
      { name: "MSc Marine Biology", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "£28,000–£48,000", topEmployers: ["Shell", "BP", "TotalEnergies", "Wood Group", "Subsea 7"] },
    intakes: ["September"], istpStudents: 13,
  },

  "university-of-dundee": {
    slug: "university-of-dundee", country: "uk",
    name: "University of Dundee", shortName: "Dundee", flag: "🇬🇧",
    city: "Dundee, Scotland", founded: 1881, qsRank: "#367 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Ranked #1 in the UK for biological sciences multiple times. World-class in cancer research, dentistry, and game design (home to Rockstar Games' founding team). Dundee is a UNESCO City of Design.",
    tuition: { domestic: "£9,250/yr", international: "£16,000–£22,000/yr" },
    living: "£750–£1,050/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Cancer Biology", duration: "1 year", language: "English" },
      { name: "MSc Computing Science", duration: "1 year", language: "English" },
      { name: "MSc Applied Computing", duration: "1 year", language: "English" },
      { name: "MSc International Business", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "£27,000–£43,000", topEmployers: ["NHS Tayside", "NCR", "Rockstar Games", "Michelin", "BioRemedyGen"] },
    intakes: ["September"], istpStudents: 11,
  },

  "coventry-university": {
    slug: "coventry-university", country: "uk",
    name: "Coventry University", shortName: "Coventry", flag: "🇬🇧",
    city: "Coventry, England", founded: 1843, qsRank: "#601 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The UK's most popular post-graduate destination for international students. TEF Gold rated. Strong in automotive engineering, business, and cybersecurity with a modern city-centre campus.",
    tuition: { domestic: "£9,250/yr", international: "£15,500–£20,500/yr" },
    living: "£750–£1,050/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Data Science & Computational Intelligence", duration: "1 year", language: "English" },
      { name: "MSc Automotive Engineering", duration: "1 year", language: "English" },
      { name: "MBA — Coventry Business School", duration: "1 year", language: "English" },
      { name: "MSc Cybersecurity", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "87%", avgSalary: "£26,000–£40,000", topEmployers: ["Jaguar Land Rover", "IBM", "Deloitte", "NHS", "PwC"] },
    intakes: ["September", "January"], istpStudents: 32,
  },

  "university-of-portsmouth": {
    slug: "university-of-portsmouth", country: "uk",
    name: "University of Portsmouth", shortName: "Portsmouth", flag: "🇬🇧",
    city: "Portsmouth, England", founded: 1869, qsRank: "#701 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "TEF Gold rated with one of the UK's lowest tuition fees. Home to the Institute of Cosmology & Gravitation. Strong in criminology, computing, and business. Easy London access via fast train.",
    tuition: { domestic: "£9,250/yr", international: "£14,000–£18,500/yr" },
    living: "£750–£1,050/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Data Science", duration: "1 year", language: "English" },
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
      { name: "MSc Forensic Accounting", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "86%", avgSalary: "£25,000–£40,000", topEmployers: ["Royal Navy", "BAE Systems", "IBM", "NHS", "PwC"] },
    intakes: ["September", "January"], istpStudents: 21,
  },

  "oxford-brookes": {
    slug: "oxford-brookes", country: "uk",
    name: "Oxford Brookes University", shortName: "Oxford Brookes", flag: "🇬🇧",
    city: "Oxford, England", founded: 1865, qsRank: "#701 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Ranked the UK's #1 modern university multiple times. Located in Oxford — the world's most famous university city. Excellent for architecture, business, and hospitality management.",
    tuition: { domestic: "£9,250/yr", international: "£15,000–£19,000/yr" },
    living: "£900–£1,200/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc International Hospitality Management", duration: "1 year", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
      { name: "MSc Architecture", duration: "1.5 years", language: "English" },
      { name: "MSc Project Management", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "87%", avgSalary: "£26,000–£40,000", topEmployers: ["BMW MINI", "NHS", "KPMG", "Hilton Hotels", "Volkswagen"] },
    intakes: ["September", "January"], istpStudents: 18,
  },

  "sheffield-hallam": {
    slug: "sheffield-hallam", country: "uk",
    name: "Sheffield Hallam University", shortName: "Sheffield Hallam", flag: "🇬🇧",
    city: "Sheffield, England", founded: 1843, qsRank: "#801 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "One of the UK's largest universities with 35,000+ students. TEF Gold rated. Strong in sport, business, and nursing. The advanced manufacturing research ecosystem keeps graduate employment high.",
    tuition: { domestic: "£9,250/yr", international: "£14,000–£18,000/yr" },
    living: "£700–£1,000/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Data Analytics", duration: "1 year", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
      { name: "MSc Sport Management", duration: "1 year", language: "English" },
      { name: "MSc Advanced Computer Science", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "86%", avgSalary: "£25,000–£39,000", topEmployers: ["Boeing", "NHS", "Sheffield City Council", "KPMG", "BT"] },
    intakes: ["September", "January"], istpStudents: 24,
  },

  "manchester-metropolitan": {
    slug: "manchester-metropolitan", country: "uk",
    name: "Manchester Metropolitan University", shortName: "MMU", flag: "🇬🇧",
    city: "Manchester, England", founded: 1824, qsRank: "#801 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The UK's most popular university by application numbers. Located in the heart of Manchester. Strong in business, fashion, and digital innovation with outstanding industry connections.",
    tuition: { domestic: "£9,250/yr", international: "£14,000–£18,500/yr" },
    living: "£800–£1,100/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
      { name: "MSc International Fashion Management", duration: "1 year", language: "English" },
      { name: "MSc Data Science", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "86%", avgSalary: "£26,000–£40,000", topEmployers: ["Co-op", "Manchester City FC", "ITV", "NHS", "PwC"] },
    intakes: ["September", "January"], istpStudents: 27,
  },

  "northumbria-university": {
    slug: "northumbria-university", country: "uk",
    name: "Northumbria University", shortName: "Northumbria", flag: "🇬🇧",
    city: "Newcastle, England", founded: 1969, qsRank: "#801 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "TEF Gold rated and one of the UK's top modern universities. Strong in law, business, engineering, and sport. Newcastle is one of the UK's most affordable and lively student cities.",
    tuition: { domestic: "£9,250/yr", international: "£14,500–£18,500/yr" },
    living: "£700–£1,000/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
      { name: "LLM International Law", duration: "1 year", language: "English" },
      { name: "MSc Civil Engineering", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "85%", avgSalary: "£25,000–£38,000", topEmployers: ["Sage", "Accenture", "PwC", "NHS", "Virgin Money"] },
    intakes: ["September", "January"], istpStudents: 20,
  },

  "de-montfort-university": {
    slug: "de-montfort-university", country: "uk",
    name: "De Montfort University", shortName: "DMU", flag: "🇬🇧",
    city: "Leicester, England", founded: 1870, qsRank: "#801 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "Award-winning city-centre campus in the East Midlands. Strong in cyber security, accounting, fashion technology, and law. Consistently in the top 10 for student experience and very affordable.",
    tuition: { domestic: "£9,250/yr", international: "£13,500–£17,500/yr" },
    living: "£700–£1,000/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Cyber Security", duration: "1 year", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "LLM Law", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "85%", avgSalary: "£24,000–£38,000", topEmployers: ["KPMG", "NHS", "BT", "Santander", "PwC"] },
    intakes: ["September", "January"], istpStudents: 18,
  },

  "nottingham-trent": {
    slug: "nottingham-trent", country: "uk",
    name: "Nottingham Trent University", shortName: "NTU", flag: "🇬🇧",
    city: "Nottingham, England", founded: 1843, qsRank: "#801 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=900&auto=format&fit=crop",
    overview: "The UK's highest-ranking modern university in the Guardian. Times Higher Education Modern University of the Year 2023. Outstanding for fashion, law, and architecture.",
    tuition: { domestic: "£9,250/yr", international: "£14,000–£17,500/yr" },
    living: "£750–£1,050/mo", ielts: "6.0+", gre: "Not required",
    topCourses: [
      { name: "MSc Data Science", duration: "1 year", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
      { name: "MSc Fashion Management", duration: "1 year", language: "English" },
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "86%", avgSalary: "£25,000–£39,000", topEmployers: ["Boots", "PwC", "NHS", "Capital One", "Experian"] },
    intakes: ["September", "January"], istpStudents: 22,
  },
};